<template>
  <el-dialog
    :visible.sync="visible"
    :title="`Now Playing: ${track && track.title ? track.title : ''}`"
    width="700px"
    custom-class="premium-modal player-modal"
    @close="$emit('close')"
  >
    <div class="track-player-content">
      <div class="track-info">
        <img v-if="track && track.album && track.album.artwork && track.album.artwork.path"
             :src="host + '/' + track.album.artwork.path"
             class="track-artwork"
             alt="Track artwork" />
        <div class="track-details">
          <h3>{{ track && track.title ? track.title : '' }}</h3>
          <p>{{ track && track.album && track.album.artist && track.album.artist.name ? track.album.artist.name : 'Unknown Artist' }}</p>
          <p class="track-meta">{{ track && track.album && track.album.release_title ? track.album.release_title : '' }}</p>
        </div>
      </div>

      <div class="audio-player-wrapper">
        <audio ref="mainAudioPlayer" controls style="width: 100%;">
          <source :src="audioSource" type="audio/wav">
        </audio>
      </div>

      <div class="track-indicators" v-if="track">
        <el-tag v-if="track.ai && track.ai.is_ai_generated" type="warning">
          <i class="el-icon-cpu"></i> AI Generated
        </el-tag>
        <el-tag v-if="track.duplicates_count > 0" type="danger">
          <i class="el-icon-copy-document"></i> {{ track.duplicates_count }} Duplicate(s)
        </el-tag>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TrackPlayerModal',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    track: {
      type: Object,
      default: null
    },
    audioSource: {
      type: String,
      default: ''
    },
    host: {
      type: String,
      default: ''
    }
  },

  watch: {
    visible(val) {
      if (!val) {
        // Reset audio player when modal closes
        if (this.$refs.mainAudioPlayer) {
          this.$refs.mainAudioPlayer.pause()
          this.$refs.mainAudioPlayer.currentTime = 0
        }

        this.$emit('update:visible', false)
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Premium Modal Styles
.premium-modal {
  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #e55279 0%, #9b6dbb 100%);
    padding: 20px;

    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: white;
      font-size: 20px;

      &:hover {
        color: #f0f0f0;
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 30px;
  }
}

// Track Player Modal Styles
.player-modal {
  ::v-deep .track-player-content {
    .track-info {
      display: flex;
      gap: 25px;
      margin-bottom: 30px;
      padding: 25px;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 12px;

      .track-artwork {
        width: 120px;
        height: 120px;
        object-fit: cover;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .track-details {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h3 {
          margin: 0 0 10px 0;
          font-size: 24px;
          color: #212529;
        }

        p {
          margin: 0 0 5px 0;
          color: #666;
          font-size: 14px;

          &.track-meta {
            color: #868e96;
            font-size: 12px;
            margin-top: 10px;
          }
        }
      }
    }

    .audio-player-wrapper {
      margin-bottom: 25px;

      audio {
        width: 100%;
        outline: none;

        &::-webkit-media-controls-panel {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        }
      }
    }

    .track-indicators {
      display: flex;
      gap: 10px;
      justify-content: center;

      .el-tag {
        padding: 8px 16px;
        font-weight: 600;

        i {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>